import React, { useCallback, useEffect, useMemo, useState } from "react";
import { LanguageSwitcherSelectors } from "../../redux/selectors";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useClickOutside } from "../../hooks";
import { useSelector } from "react-redux";
import { BrandUtils } from "../../utils/brandUtils";
import { LocalizationUtils } from "../../utils/localizationUtils";

export const LanguagesMenuPC = ({
  toggleClass,
  languages,
  countries,
  active,
  trackingInfo
}) => {
  const currentRef = useClickOutside(
    () => {
      resetMouseEnteredState();
      toggleClass(false);
    },
    { disabled: !active }
  );

  const [trackingInfoLocal, setTrackingInfoLocal] = useState(trackingInfo);

  const data = useSelector(LanguageSwitcherSelectors.data);
  const lang = useSelector(LanguageSwitcherSelectors.lang);
  const showCountrySelection = !BrandUtils.isPokerClient();

  const classes = useMemo(
    () =>
      classNames("languageBtn", { showLanguageOptions: active }, "circleIcon"),
    [active]
  );

  useEffect(() => {
    setTrackingInfoLocal(
      trackingInfo
        ? Object.assign({}, trackingInfo, { dataLabel: "Language Switcher" })
        : Object.assign({}, trackingInfo, {
            dataCategory: "default",
            dataAction: "click",
            dataLabel: "Language Switcher"
          })
    );
  }, [trackingInfo]);

  const [mouseEntered, setMouseEntered] = useState(false);
  let mouseEnterTimeOut = null;

  const onMouseLeaveHandler = () => {
    if (mouseEntered === true) {
      toggleClass();
    }
    resetMouseEnteredState();
  };

  const onMouseEnterHandler = () => {
    mouseEnterTimeOut = setTimeout(() => {
      setMouseEntered(true);
    }, 50);
  };

  const onClick = () => {
    resetMouseEnteredState();
    toggleClass();
  };

  const resetMouseEnteredState = useCallback(() => {
    setMouseEntered(false);
    if (mouseEnterTimeOut) clearTimeout(mouseEnterTimeOut);
  }, [mouseEnterTimeOut]);

  useEffect(() => {
    return () => {
      resetMouseEnteredState();
    }; // destruct lifecycle
  }, [resetMouseEnteredState]);

  return (
    <div id="languagePC" onClick={onClick} ref={currentRef}>
      <a
        className={classes}
        data-category={trackingInfoLocal.dataCategory}
        data-action={trackingInfoLocal.dataAction}
        data-label={trackingInfoLocal.dataLabel}
        data-value=""
      >
        <span>{LocalizationUtils.getMappedLanguage(lang)}</span>
      </a>
      <div
        className="languageOptionsPC"
        onMouseEnter={onMouseEnterHandler}
        onMouseLeave={onMouseLeaveHandler}
      >
        <p>
          {!!data?.languageSettings?.title
            ? data.languageSettings.title
            : "Choose your Language:"}
        </p>

        <ul className="languageSelect">{languages}</ul>

        <div className="clear" />

        {showCountrySelection && (
          <>
            <hr />
            <p>
              {!!data.countrySettings && !!data.countrySettings.title
                ? data.countrySettings.title
                : "Choose your Country:"}
            </p>
            <ul className="countrySelect">{countries}</ul>
          </>
        )}
      </div>
    </div>
  );
};

LanguagesMenuPC.propTypes = {
  languages: PropTypes.array,
  countries: PropTypes.array,
  toggleClass: PropTypes.func,
  active: PropTypes.bool,
  trackingInfo: PropTypes.object
};
